<div id="delivery-details-assessment-allocation-settings">
    <div>
        <label for="assessment-allocation-dr-team-retrieves-wp">DR Team Retrieves</label>
        <div class="checkbox">
            <label>
                <input
                    id="assessment-allocation-dr-team-retrieves-wp"
                    type="checkbox"
                    [(ngModel)]="currentData.drTeamRetrievesWP"
                    [disabled]="!allowEdit()"
                    data-qa="assessment-allocation-dr-team-retrieves-wp">
                WP
            </label>
        </div>
    </div>
    <div>
        <div>
            <label for="assessment-allocation-reviewer">Allocation Reviewer</label>
        </div>
        @if (allowEdit()) {
            <div class="allocation-reviewer-user">
                <user-team-picker
                    id="assessment-allocation-reviewer"
                    style="min-width: 300px;"
                    [user]="currentData.allocationReviewerUser"
                    [userId]="currentData.allocationReviewerUserID"
                    [teamId]="currentData.allocationReviewerTeamID"
                    [entityIdScope]="entity.id"
                    [entityTypeScope]="entity.type"
                    [instanceIdScope]="userSearchInstanceId"
                    (userChange)="userChanged($event)"
                    data-qa="assessment-allocation-reviewer-picker"
                >
                </user-team-picker>
                <button
                    class="ace-btn has-icon btn-primary btn-danger"
                    (click)="userChanged(undefined)"
                    data-qa="assessment-allocation-reviewer-clear">
                    <i class="fa fa-trash"></i>
                </button>
            </div>
        }
        @if (!allowEdit()) {
            <span
                ngClass="allocation-reviewer-user">
          {{ getDisplayName(currentData.allocationReviewerUser, currentData.allocationReviewerTeam) }}
        </span>
        }
    </div>
</div>
